const UUID_LENGTH = 36;
export const setDealProductPartyNumbers = (
  farmId,
  dealType,
  dealService,
  setValue,
  getValues,
  originalFormValues
) => {
  const params = {
    product_id: getValues('product_id.value'),
    amount: getValues('amount'),
    unit: getValues('unit.value'),
    exclude_deal_product_ids: [],
  };

  if (
    (originalFormValues?.id ?? false) &&
    originalFormValues.id.length === UUID_LENGTH
  ) {
    params.exclude_deal_product_ids = [originalFormValues.id];
  }

  if (
    !params?.product_id ||
    !params.amount ||
    !params.unit ||
    (originalFormValues?.amount === params.amount &&
      originalFormValues?.product_id?.value === params.product_id)
  ) {
    return;
  }

  dealService
    .generatePartyNumber(farmId, dealType, params)
    .subscribe((list) => {
      setValue('product_warehouses', list, {
        shouldValidate: true,
      });
    });
};
